module.exports = __webpack_public_path__ + "static/media/synkmobil.253e36c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/synkmobil.svg
// module id = 6850
// module chunks = 0